import React from "react";
import Badge from "@material-ui/core/Badge";
import Tooltip from "@material-ui/core/Tooltip";
import { makeStyles } from "@material-ui/core/styles";
import WhatsAppIcon from "@material-ui/icons/WhatsApp";

import ContactAvatar from "../ContactAvatar";

// ---------------------------------------------------------------------------
// ChannelAvatar — ContactAvatar com um selo do canal de origem no canto
// inferior direito.
//
// Hoje o único canal é o WhatsApp e não existe campo de canal no banco, então
// getTicketChannel sempre devolve "whatsapp". Quando outros canais entrarem,
// basta ler o campo novo aqui e registrar o ícone/cor em CHANNELS.
// ---------------------------------------------------------------------------
const CHANNELS = {
  whatsapp: { label: "WhatsApp", Icon: WhatsAppIcon, color: "#25D366" },
};

export const getTicketChannel = (ticket) => {
  const channel = ticket?.whatsapp?.channel || ticket?.channel;
  return CHANNELS[channel] ? channel : "whatsapp";
};

const useStyles = makeStyles((theme) => ({
  badge: {
    padding: 0,
    minWidth: 0,
    width: 18,
    height: 18,
    borderRadius: "50%",
    backgroundColor: theme.palette.background.paper,
    boxShadow: `0 0 0 1.5px ${theme.palette.background.paper}`,
  },
  icon: {
    fontSize: 14,
  },
}));

const ChannelAvatar = ({ channel = "whatsapp", ...avatarProps }) => {
  const classes = useStyles();
  const { label, Icon, color } = CHANNELS[channel] || CHANNELS.whatsapp;

  return (
    <Badge
      overlap="circular"
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      classes={{ badge: classes.badge }}
      badgeContent={
        <Tooltip title={label}>
          <Icon className={classes.icon} style={{ color }} />
        </Tooltip>
      }
    >
      <ContactAvatar {...avatarProps} />
    </Badge>
  );
};

export default ChannelAvatar;
